import { CompoundButton, FontIcon } from "@fluentui/react";
import { PersonAddFilled } from "@fluentui/react-icons";
import ThemeBase from "../../utils/Theme/themeBase";

export interface IButtonLoginMicrosoft {
  onclick: () => void;
}

const ButtonLoginMicrosoft = ({ onclick }: IButtonLoginMicrosoft) => {
  return (
    <CompoundButton
      secondaryText=""
      //disabled={loginDisabled}
      checked={false}
      onClick={onclick}
      //styles={!loginDisabled ? ThemeBase.buttonHome : {}}
      styles={ThemeBase.buttonHome}
      //style={loginDisabled ? styleInDisabled : {}}
      style={{}}
    >
      <div
        style={{
          display: "flex",
          alignItems: "center",
        }}
      >
        <div>
          <FontIcon
            aria-label={"AddFriend"}
            iconName={"AddFriend"}
            className={ThemeBase.classes.icon}
          />
          <div>MMG</div>
        </div>
      </div>
    </CompoundButton>
  );
};

export { ButtonLoginMicrosoft };